/** @format */

import { defaultActions } from '../../core/actionsDefault';

// const _ = require('underscore');

export const vatConstants = {
    VAT_LIST: 'vat_list',
};

export class VatActions extends defaultActions {}
